import { ActionOption } from './version.dto';

export const TimestampField = 'Date & Time';
export const AppDecodeField = 'Application';
export const ApplicationField = 'Application';

export const ThreatNameField = 'Threat Name';
export interface LogsDto {
    [TimestampField]: string;
    Category?: string;
    URL?: string;
    Direction: string;
    'Source IP': string;
    'Source Country': string;
    'Destination IP': string;
    'Destination Country': string;
    Action: ActionOption;
    'IP Protocol': string;
    'To Port': string;
    'Session Duration'?: number;
    'Bytes Sent': number;
    'Bytes Received': number;
    'Session End Reason': string;
    Rule: string;
    Severity?: string;
    'Threat Type'?: string;
    'Threat Name'?: string;
    [ApplicationField]: string;
    'Child App': string;
}
